export default __webpack_public_path__ + "static/media/norway_icon.eb319d1e.png";